import React from 'react'
import clsx from "clsx"

export default class Panel extends React.Component {

	constructor(props) {
		super(props);

    this.onExpandCollapse = this.onExpandCollapse.bind(this);
	}


	render() {
    // console.log('render Panel', this.props);
    var panelClasses = clsx({
      'panel-body': true, 
      'expanded': this.props.expanded,
      'collapsed': !this.props.expanded, 
    })

		return (
      <div className="MaxPanel">
        <div className="card panel panel-default">
          <div className={panelClasses} onClick={this.onExpandCollapse}>
            {this.renderHeader()}
            {this.renderBody()}
          </div>
        </div>
      </div>
		);
	}

  renderArrow() {
    if (this.props.expanded) {
      return <span className="arrow-down can-expand-collase"></span>
    } else {
      return <span className="arrow-right can-expand-collase"></span>
    }
  }

  renderBody() {
    if (this.props.expanded && this.props.body) {
      return (
        <div className="expand-collapse-body" style={this.props.add_info_pan == true ? {padding: "0px"} : null}>
          {this.props.body}
        </div>
      );
    }
  }

  renderHeader() {
    if (this.props.header) {
      return (
        <div className="expand-collapse-header can-expand-collase" onClick={this.onExpandCollapse}>
          {this.props.header}
          {this.props.onExpandCollapse && typeof this.props.onExpandCollapse == 'function' ? this.renderArrow() : null}
        </div>
      );
    } else if (typeof this.props.onExpandCollapse === 'function') {
      return this.renderArrow();
    }
  }

  /**
  * Change handlers
  */

  onExpandCollapse(e) {
    // if (this.props.expanded) {
    //   // do nothing
    // } else {
      if (typeof this.props.onExpandCollapse === 'function' && (e.target.classList.contains('can-expand-collase'))) {
        this.props.onExpandCollapse(this.props.name, e);
      }
    // }
  }

}